import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import React, { ReactNode } from "react";

type DropdownContentLayoutProps = {
  children: ReactNode;
  className?: string;
};

export const DropdownContentLayout: React.FC<DropdownContentLayoutProps> = ({
  children,
  className = "",
}) => {
  return (
    <NavigationMenu.Content
      className={`absolute left-0 w-full border-solid border-t-2 border-gray-100`}
    >
      <div className="flex max-w-[1280px] mx-auto lg:mx-10">
        <div className={`pt-12 pb-16 w-full flex animate-slideUp ${className}`}>
          {children}
        </div>
      </div>
    </NavigationMenu.Content>
  );
};
